import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import IconPrint from "@material-ui/icons/Print";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import React, { useEffect, useState } from "react";
import { colorsV2 } from "../../../styles/colors";
import physioLogo from "../../../resources/logo/physiotec_logo.png";
import colors from "../../../styles/colors";

const styles = {
  card: {
    heigh: 350,
    width: 300,
    borderColor: colorsV2.primary,
    borderRadius: 8,
    borderWidth: 1,
    borderStyle: "solid",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    marginLeft: 10,
    marginBottom: 10,
    boxShadow: "1px 3px 1px #9E9E9E",
    alignItems: "center",
    justifyContent: "center",
  },
  row: {
    flexDirection: "row",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 5,
  },
  title: {
    fontFamily: "Poppins-Regular",
    color: colorsV2.codGray,
    fontSize: 14,
  },
  group: {
    fontSize: 12,
    fontFamily: "Poppins-Regular",
    color: colorsV2.main,
    padding: 3,
    border: "1px solid",
    borderRadius: 3,
    background: colorsV2.lightViking,
    borderColor: colorsV2.main,
  },
  libraryContent: {
    width: 300,
    height: 260,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
  description: {
    fontSize: 12,
    display: "block",
    fontFamily: "Poppins-Regular",
    color: colorsV2.lightGrey,
    flex: 1,
    overflow: "hidden",
    textAlign: "left",
    textOverflow: "ellipsis",
  },
  descriptionShort: {
    maxHeight: 145,
  },
  descriptionLong: {
    maxHeight: 250,
  },
  libraryImage: {
    width: 100,
    height: 100,
    marginRight: 15,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
  actionButtons: {
    width: "100%",
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    color: colorsV2.codGray,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
  },
};

export default (props) => {
  const libInstruction = props.instruction;
  const [thumb, setThumb] = useState(null);

  useEffect(() => {
    if (libInstruction.library.videoPreviewUrl) {
      setThumb(libInstruction.library.videoPreviewUrl);
      return;
    } else if (libInstruction.library.imageUrl) {
      setThumb(libInstruction.library.imageUrl);
      return;
    } else if (libInstruction.library.physioImage) {
      setThumb(libInstruction.library.physioImage);
      return;
    } else if (
      libInstruction.library.youtubeVideo &&
      libInstruction.library.youtubeVideo.id
    ) {
      const thumbUrl =
        "http://img.youtube.com/vi/" +
        libInstruction.library.youtubeVideo.id +
        "/maxresdefault.jpg";
      setThumb(thumbUrl);
      return;
    } else if (
      libInstruction.library.wistiaVideo &&
      libInstruction.library.wistiaVideo.id
    ) {
      const wistiaVideoUrl =
        "https://fast.wistia.net/oembed?url=https://home.wistia.com/medias/" +
        libInstruction.library.wistiaVideo.id;
      fetch(wistiaVideoUrl)
        .then((response) => response.json())
        .then((data) => {
          setThumb(data.thumbnail_url);
          return;
        })
        .catch((err) => console.log("Wistia Error caught:", err));
    } else {
      setThumb(props.coverUrl);
      return;
    }
  });

  const editLibraryItem = (category) => {
    if (!category.library.isLocked) {
      props.editLibrary(category);
    }
  };

  const addAppFavorite = (instructionId) => {
    props.addAppFavorite(instructionId);
  };
  const deleteAppFavorite = (instructionId) => {
    props.deleteAppFavorite(instructionId);
  };

  return (
    <div
      style={{
        textDecoration: "none",
        listStyle: "none",
        width: "100%",
        border: "solid 1px grey",
        padding: 10,
        marginTop: 10,
        borderRadius: 7,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "row",
          margin: 0,
          padding: 0,
        }}
      >
        {thumb !== null && (
          <div
            style={{
              ...styles.libraryImage,
              backgroundImage: `url(${thumb})`,
            }}
          ></div>
        )}
        <div
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "row",
              justifyContent: "space-between",
              margin: 0,
              padding: 0,
            }}
          >
            <div
              style={{
                margin: 0,
                padding: 0,
                display: "flex",
                flexDirection: "row",
                justifyItems: "flex-start",
                alignItems: "center",
              }}
            >
              {libInstruction.library.isFavorite ? (
                <StarIcon
                  fontSize="small"
                  style={{ color: "orange" }}
                  onClick={() => {
                    deleteAppFavorite(libInstruction.library.categoryId);
                  }}
                />
              ) : (
                <StarBorderIcon
                  fontSize="small"
                  onClick={() => {
                    addAppFavorite(libInstruction.library.categoryId);
                  }}
                />
              )}
              <div
                style={{
                  fontSize: 16,
                  fontFamily: "Poppins-Semibold",
                }}
              >
                {libInstruction.library.categoryName}
              </div>
              <div style={{ marginLeft: 30 }}>
                <span
                  style={{
                    margin: 0,
                    padding: 5,
                    backgroundColor: colors.primary,
                    color: colors.white,
                    borderRadius: 5,
                    fontSize: 12,
                    fontFamily: "Poppins-Regular",
                  }}
                >
                  {libInstruction.library.groupName}
                </span>
              </div>
            </div>
            <div style={{ margin: 0, padding: 0 }}>
              <div style={styles.actionButtons}>
                {libInstruction.library.isLocked && (
                  <div style={{ marginRight: 15 }}>
                    <img src={physioLogo} alt="Physiotec" />
                  </div>
                )}
                <DeleteIcon
                  fontSize="small"
                  onClick={() => props.deleteLibrary(libInstruction)}
                />
                {!libInstruction.library.isLocked && (
                  <CreateIcon
                    fontSize="small"
                    onClick={() => props.editLibrary(libInstruction)}
                  />
                )}
                <IconPrint
                  onClick={() => props.printInstruction(libInstruction)}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "column",
            }}
          >
            <div>
              <div
                style={{
                  margin: 5,
                  fontSize: 12,
                  color: colors.grey,
                }}
              >
                {libInstruction.library.categoryDesc}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/layout/libraries/libraryPage/LibraryInstructionCard.js